import Vue from "vue";
import ApiState from '@/enums/APISTATE';

export default {
  namespaced: true,
  state: {
    apiState: ApiState.INIT,
    selectedAllocations: {},

  },
  mutations: {
    setApiState(state, apiState) {
      state.apiState = apiState;
    },
    addSelection(state, allocation) {
      if (!Object.prototype.hasOwnProperty.call(state.selectedAllocations, allocation.id)) {
        // state.selectedAllocations[allocation.id] = allocation;
        Vue.set(state.selectedAllocations, allocation.id, allocation);
      }
      else {
        Vue.delete(state.selectedAllocations, allocation.id);
      }
    },
    clearSelection(state) {
      Vue.set(state, 'selectedAllocations', {});
    }

  },
  actions: {
    selectAllocation({commit, rootGetters}, allocation) {
      if (rootGetters.isReplacement || rootGetters.hasEditRights === false){
        return;
      }

      commit('addSelection', allocation);
    },
    async selectMoveTarget({commit, dispatch, state}, {rowData, rowDataKey, allocationRowDataKey = rowDataKey}) {
      if (state.apiState === ApiState.LOADING)
        return;

      commit('setApiState', ApiState.LOADING);
      try {
        for (let allocationId of Object.keys(state.selectedAllocations)) {
          let allocation = state.selectedAllocations[allocationId];
          allocation[allocationRowDataKey] = rowData[rowDataKey];
          await dispatch('scheduler/updateAllocation', { allocation }, { root: true });
        }
        dispatch('clearSelection');
        commit('setApiState', ApiState.LOADED);
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ApiState.ERROR);
      }
    },
    clearSelection({commit}) {
      commit('clearSelection');
    }

  },
  getters: {
    awaitingSelection: state => Object.keys(state.selectedAllocations).length > 0,
    allocationSelectionClass: state => (allocation) => Object.prototype.hasOwnProperty.call(state.selectedAllocations, allocation.id) ? 'allocation-selection__allocation--selected' : '',
    isAllocationSelected: state => (allocation) => Object.prototype.hasOwnProperty.call(state.selectedAllocations, allocation.id),
    moveTargetClass: state => ({rowData, rowDataKey}) => {
      const output = [];
      output.push('allocation-selection__target');
      if (Object.keys(state.selectedAllocations).length > 0) {
        output.push('allocation-selection__target--active');
      }
      return output;
    }
  }
}
